export default __webpack_public_path__ + "static/media/sample_meeting.2f6ed1c1.xlsx";